var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"text-18 md-text-24 text-center mb-30 md-mb-50",class:_vm.index > 0 ? 'mt-120 md-mt-164' : 'mt-53'},[(_vm.row.link)?_c('wp-link',{attrs:{"link":_vm.row.link}},[_vm._v(_vm._s(_vm.row.header))]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.row.header)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }